import React, { useState, useEffect, useRef } from "react";
import "../../../App.css";
import PageTitle from "../../../Module/pageTitle";
import { useDispatch, useSelector } from "react-redux";
import LabelField from "../../../Component/labelField";
import CustomDropdown from "../../../Component/customDropdown";
import {
  getStockManagementList,
  getExamListNew,
  getParentCourseNew,
  getPubStockHistoryList,
} from "../../../Action/courseAction";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { BookStatusList } from "../../../Utils/dataConstants";
import AdminTable from "../../../Component/adminTable";
import moment from "moment";
import SubmitButton from "../../../Component/SubmitButton";
import { getSubExam } from "../../../Action/adminPanelAction";
import DatePicker from "../../../Component/datePicker";
import Dropdown from "../../../Component/dropdown";

function PubBookHistory() {
  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const [examStream, setExamStream] = useState("");
  const [exam, setExam] = useState("");
  const [subExam, setSubExam] = useState("");
  const [bookStatus, setBookStatus] = useState("");

  const [bookId, setBookId] = useState("");
  const [bookName, setBookName] = useState("");
  const [bookQuantity, setBookQuantity] = useState("");

  const [examStreamList, setExamStreamList] = useState([]);
  const [examList, setExamList] = useState([]);
  const [subExamList, setSubExamList] = useState([]);
  const [stockList, setStockList] = useState([]);
  const [stockHistory, setStockHistory] = useState([]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [isViewMode, setIsViewMode] = useState(false);

  useEffect(() => {
    dispatch(
      getExamListNew((res) => {
        setExamList(res);
      })
    );
    fetchData({});
  }, []);

  const fetchData = (postData) => {
    dispatch(
      getStockManagementList(
        postData,
        (res) => {
          if (bookStatus?._id === 1) {
            setStockList(res?.data);
          } else if (bookStatus?._id === 2) {
            let tempData = res?.data?.filter((item) => item?.status === 1);
            setStockList(tempData);
          } else if (bookStatus?._id === 3) {
            let tempData = res?.data?.filter((item) => item?.status === 0);
            setStockList(tempData);
          } else {
            setStockList(res?.data);
          }
        },
        () => {}
      )
    );
  };

  const onChangeExamStream = (value) => {
    setExamStream(value);
    setBookStatus("");
    setStockList([]);
  };

  const onChangeExam = (value) => {
    setExam(value);
    setSubExam("");
    setSubExamList([]);
    setExamStream("");
    setExamStreamList([]);
    setBookStatus("");
    setStockList([]);
    if (value) {
      dispatch(
        getSubExam(
          {
            examTypeId: value._id,
          },
          (res) => {
            if (res.data.length > 0) setSubExamList(res.data);
            else
              dispatch(
                getParentCourseNew(`${value._id}`, (res) => {
                  setExamStreamList(res);
                })
              );
          }
        )
      );
    }
  };
  const onChangeSubExam = (value) => {
    setSubExam(value);
    setExamStream("");
    setExamStreamList([]);
    setBookStatus("");
    setStockList([]);
    if (value) {
      dispatch(
        getParentCourseNew(`${exam._id}/${value._id}`, (res) => {
          setExamStreamList(res);
        })
      );
    }
  };

  const onChangeBookStatus = (value) => {
    setBookStatus(value);
    setStockList([]);
  };

  const handlesearch = (e) => {
    e.preventDefault();
    const postData = {
      baseCourseId: examStream._id,
      examTypeId: exam._id,
    };
    if (subExam) {
      postData["subExamTypeId"] = subExam._id;
    }
    fetchData(postData);
  };

  const handleView = (value) => {
    setBookId(value?._id);
    setBookName(value?.name);
    setBookQuantity(value?.quantity);
    const postdata = {
      bookId: value?._id,
      startDate: moment.utc(new Date()).format("yyyy-MM-DD"),
      endDate: moment.utc(new Date()).format("yyyy-MM-DD"),
    };
    dispatch(
      getPubStockHistoryList(postdata, (res) => {
        setStockHistory(res.data);
      })
    );
    setStartDate(moment.utc(new Date()).format());
    setEndDate(moment.utc(new Date()).format());
    setIsViewMode(true);
  };

  const handleCancelEditMode = () => {
    setIsViewMode(false);
  };

  const renderListMode = () => {
    return (
      <div className="formDiv ">
        <form className="row mt-2" onSubmit={handlesearch}>
          <div className="col-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Exam Name"} />
            <div className="w-100">
              <Dropdown
                labelName="Select Exam Name"
                setInputText={(value) => onChangeExam(value)}
                options={examList}
                value={exam}
              />
            </div>
          </div>
          {subExamList?.length > 0 ? (
            <div className="col-4 d-flex mb-2 align-items-center">
              <LabelField labelName={"Sub Exam Name"} />
              <div className="w-100">
                <Dropdown
                  labelName="Select Sub Exam Name"
                  setInputText={(value) => onChangeSubExam(value)}
                  options={subExamList}
                  value={subExam}
                />
              </div>
            </div>
          ) : null}
          <div className="col-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Exam Stream"} />
            <div className="w-100">
              <Dropdown
                labelName="Select Exam Stream"
                setInputText={(value) => onChangeExamStream(value)}
                options={examStreamList}
                value={examStream}
              />
            </div>
          </div>
          <div className="col-4 d-flex mb-2 align-items-center">
            <LabelField labelName={"Book Status"} />
            <div className="w-100">
              <Dropdown
                labelName="Select Book Status"
                setInputText={(value) => onChangeBookStatus(value)}
                options={BookStatusList}
                value={bookStatus}
              />
            </div>
          </div>
          <div className="d-flex justify-content-center me-3">
            <SubmitButton name="Search" />
          </div>
        </form>
        <div className=" d-flex flex-row-reverse mt-3">
          <DownloadTableExcel
            filename="Publication Book History"
            sheet="users"
            currentTableRef={tableRef.current}
          >
            <button
              type="button"
              className={`btn rounded-pill me-1 font-12 ${
                stockList.length > 0 ? "btn-primary" : "btn-secondary"
              }`}
            >
              Export Report
            </button>
          </DownloadTableExcel>
        </div>
        <div ref={tableRef}>
          <AdminTable
            pagename={"stockManagement"}
            tableHead={[
              "S.N",
              "EXAM STREAM",
              "EXAM NAME",
              "SUB-EXAM NAME",
              "BOOK NAME",
              "QUANTITY",
              "STATUS",
              "ACTION",
              "",
            ]}
            tableData={stockList ? stockList : []}
            className={"add_Question-btn btn btn-outline-success btn-sm"}
            handleAddOnButton={(input) => handleView(input)}
            addOnButton={true}
            addOnButtonLabel={"View"}
          />
        </div>
      </div>
    );
  };

  const filterdata = (e) => {
    e.preventDefault();
    const postdata = {
      bookId: bookId,
      startDate: startDate,
      endDate: endDate,
    };
    dispatch(
      getPubStockHistoryList(postdata, (res) => {
        setStockHistory(res.data);
      })
    );
  };
  const renderEditMode = () => {
    return (
      <>
        <div className="formDiv">
          <div className="d-flex justify-content-between pt-3 px-3">
            <p className="fw-bold">
              Book Name :<span style={{ color: "#3F51B5" }}> {bookName}</span>
            </p>
            <p className="fw-bold">
              Available Stock :
              <span style={{ color: "#3F51B5" }}> {bookQuantity}</span>
            </p>
          </div>
          <div className="row d-flex px-2 mx-0">
            <form className="col-12 formWidth" onSubmit={filterdata}>
              <div className="col-auto">
                <div className="d-flex align-items-center justify-content-between flex-wrap">
                  <div className="d-flex align-items-center me-3">
                    <LabelField labelName={"Start Date"} />
                    <DatePicker
                      setInputText={(value) => {
                        setStartDate(value);
                      }}
                      value={moment.utc(startDate).format("yyyy-MM-DD")}
                      defaultValue={moment.utc(startDate).format("yyyy-MM-DD")}
                    />
                  </div>
                  <div className="d-flex align-items-center">
                    <LabelField labelName={"End Date"} />
                    <DatePicker
                      setInputText={(value) => {
                        setEndDate(value);
                      }}
                      value={moment.utc(endDate).format("yyyy-MM-DD")}
                      defaultValue={moment.utc(endDate).format("yyyy-MM-DD")}
                    />
                  </div>
                  <div className="col-auto d-flex justify-content-center">
                    <SubmitButton name="Search" />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <AdminTable
            pagename={"PubBookHistory"}
            tableHead={[
              "S.N",
              "ADDED BY",
              "DATE & TIME",
              "LAST QUANTITY",
              "CURRENT QUANTITY",
              "QUANTITY",
              "ACTION",
              "FROM",
              "TO",
              "SELLING SOURCE",
            ]}
            tableData={stockHistory ? stockHistory : []}
            className={"text-primary fw-bold me-2 cursor"}
          />
        </div>
      </>
    );
  };

  return (
    <div className="contentBox">
      <PageTitle
        name={"BOOK HISTORY"}
        isGoBack={isViewMode}
        onClick={handleCancelEditMode}
      />
      <div className="col-12 formWidth">
        {!isViewMode ? renderListMode() : renderEditMode()}
      </div>
    </div>
  );
}

export default PubBookHistory;
